import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 1,
      /** Surface failed queries during render so route/error boundaries can catch them. */
      throwOnError: true,
    },
  },
});

/** Wipe all cached queries so the next user never sees the previous session's data. */
export const clearSessionQueryCache = (): void => {
  queryClient.clear();
};